<template>
  <div v-if="sites.length > 0" class="site-container">
    <div class="is-flex sites-border has-text-weight-bold text-grey">
      Sites
    </div>
    <table class="table is-hoverable is-fullwidth">
      <es-sorter
        :apiSorter="apiSorter"
        :columnHeaders="columnHeaders"
        @updateSorter="updateSorter"
      />
      <tbody>
        <tr v-for="site in sites" :key="site.schoolCode">
          <td class="is-paddingless">
            <es-eligibility-marker size="small" :value="site.currentISP" />
          </td>
          <td>{{ site.schoolCode }}</td>
          <td>{{ site.locationName }}</td>
          <td>{{ site.totalIdentified }}</td>
          <td>{{ site.totalEnrolled }}</td>
          <td>{{ typeof site.baseYearISP === 'number' ? site.baseYearISP.toFixed(2) : '' }}</td>
        </tr>
      </tbody>
    </table>
    <div v-if="loadingMore" style="padding: 0.5rem 0">
      <es-loader size="2x"/>
    </div>
    <a
      v-else-if="canLoadMore"
      style="padding: 0.5rem 0"
      @click="loadMore">
      Load More
    </a>
  </div>
</template>

<script>
import axios from 'axios';
import qs from 'qs';
import EsLoader from '@/components/EsLoader.vue';
import EsEligibilityMarker from '@/components/EsEligibilityMarker.vue';
import EsSorter from '@/components/EsSorter.vue';

export default {
  props: {
    clusterId: {
      type: Number,
    },
    locationGroupId: {
      type: String,
    },
    schoolYear: {
      type: Number,
    },
    cluster: {
      type: Boolean,
    },
    page: {
      type: Number,
      default: 1,
    },
    pageSize: {
      type: Number,
      default: 25,
    },
    sortField: {
      type: String,
    },
    sortOrder: {
      type: String,
    },
    columnHeaders: {
      type: Array,
    },
  },
  components: {
    EsLoader,
    EsEligibilityMarker,
    EsSorter,
  },
  data() {
    return {
      loadingMore: null,
      sites: [],
      totalCount: null,
      apiSorter: {},
    };
  },
  computed: {
    canLoadMore() {
      return (this.page * this.pageSize) < this.totalCount;
    },
    getSorter() {
      return this.columnHeaders.find(header => header.order);
    },
    urlParams() {
      const params = {};
      params.pageNum = this.page ? this.page : undefined;
      params.pageSize = this.pageSize ? this.pageSize : undefined;
      params.sort = JSON.stringify([{
        field: this.sortField,
        order: this.sortOrder,
      }]);
      return params;
    },
    updatedSorter() {
      return `${this.sortField}:${this.sortOrder}`;
    },
  },
  created() {
    this.getSites();
  },
  watch: {
    updatedSorter() {
      this.getSites();
    },
  },
  methods: {
    async getSites() {
      try {
        const res = await axios.get(`cep/${this.locationGroupId}/elections/${this.schoolYear}/clusters/${this.clusterId}/cluster-sites`,
          {
            params: this.urlParams,
            paramsSerializer(params) {
              return qs.stringify(params, { arrayFormat: 'repeat' });
            },
          });
        this.sites = res.data.data;
        this.totalCount = res.data.totalCount;
        [this.apiSorter] = res.data.sorters;
      } catch (error) {
        // handle error
      }
    },

    async loadMore() {
      this.page = this.page + 1;
      try {
        this.loadingMore = true;

        const res = await axios.get(`cep/${this.locationGroupId}/elections/${this.schoolYear}/clusters/${this.clusterId}/cluster-sites`,
          {
            params: this.urlParams,
            paramsSerializer(params) {
              return qs.stringify(params, { arrayFormat: 'repeat' });
            },
          });

        res.data.data.forEach((obj, i) => this.sites.push(obj));
      } catch (e) {
        this.page = 1;
        this.sites = [];
        this.getSites();
      } finally {
        this.loadingMore = false;
      }
    },
    updateSorter() {
      this.$emit('updateSorter');
    },
  },
};
</script>

<style lang="sass" scoped>
  .site-container
    font-size: 14px
  .sites-border
    border-bottom: 1px solid #ddd
  .text-grey
    color: #555
  .sort-by
    padding-right: 18px
    position: relative
    color: #777
    text-decoration: none
    -webkit-appearance: slider-vertical
    &:before, &:after
      border: 4px solid transparent
      content: ""
      display: block
      height: 0
      right: 5px
      top: 50%
      position: absolute
      width: 0
    &:before
      border-bottom-color: #999
      margin-top: -9px
    &:after
      border-top-color: #999
      margin-top: 1px
</style>
